import React, { useCallback } from 'react'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import { FormattedMessage } from 'react-intl'
import requestAddCardBlocker from 'store/sagas/requestAddCardBlocker'
import { useDispatch } from 'react-redux'
import { BlockerTypeField, UserField } from '../../CardBlockerForm'
import { CardModalView, ViewBody } from 'components/Sidebar'
import { Formik } from 'formik'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonGroup,
} from 'react-bootstrap'
import Button from 'components/Button'
import { useCardContext } from 'dataProviders/Card'

const initialValues: {
  blockerId: number | undefined,
  userId: number | undefined,
  reason: string | undefined,
} = {
  blockerId: undefined,
  userId: undefined,
  reason: undefined,
}

type Props = LeftSidebarProps & {
  blockerId?: number
}

const BlockCard: React.FC<Props> = ({
  leftSidebar,
  blockerId
}) => {
  const cardContext = useCardContext()

  const dispatch = useDispatch()

  const close = useCallback(() => {
    leftSidebar.pop()
  }, [])

  return (
    <CardModalView
      title={<FormattedMessage id='BLOCKERS_CARD_BLOCK_HEADER' />}
    >
      <Formik
        initialValues={{
          ...initialValues,
          blockerId,
        }}
        validate={({ blockerId }) => {
          const errors: any = {}
        
          if (!blockerId) {
            errors.blockerId = true
          }
          
          return errors
        }}
        onSubmit={({ blockerId, reason, userId }) => {
          if (blockerId) {
            dispatch(requestAddCardBlocker({
              cardId: cardContext.id,
              blockerId,
              reason,
              userId,
            }))
          }

          close()
        }}
      >
        {formik =>
          <form onSubmit={formik.handleSubmit}>
            <BlockerTypeField
              name='blockerId'
            />
            <UserField
              name='userId'
            />
            <ViewBody>
              <FormGroup>
                <ControlLabel><FormattedMessage id='BLOCKERS_CARD_BLOCK_REASON' /></ControlLabel>
                <FormattedMessage id='BLOCKERS_CARD_BLOCK_REASON_PLACEHOLDER'>
                  {formattedMessage =>
                    <FormControl
                      type='text'
                      name='reason'
                      value={formik.values.reason}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder={formattedMessage}
                    />
                  }
                </FormattedMessage>
              </FormGroup>
              <ButtonGroup>
                <Button type='submit' bsStyle='primary' disabled={formik.isSubmitting}>
                  <FormattedMessage id='BLOCKERS_CARD_BLOCK' />
                </Button>
                <Button onClick={close}><FormattedMessage id='CANCEL' /></Button>
              </ButtonGroup>
            </ViewBody>
          </form>
        }
      </Formik>
    </CardModalView>
  )
}

export default withLeftSidebar(BlockCard)
